import { saveAs } from 'file-saver';

export const flattenRecord = (record, prefix = '', result = {}) => {
  Object.entries(record || {}).forEach(([key, value]) => {
    const safeKey = key.replaceAll('\\', '\\\\').replaceAll('.', '\\.');
    const field = prefix ? `${prefix}.${safeKey}` : safeKey;
    if (value && typeof value === 'object' && !Array.isArray(value) &&
        Object.getPrototypeOf(value) === Object.prototype && Object.keys(value).length) {
      flattenRecord(value, field, result);
    } else {
      result[field] = value;
    }
  });
  return result;
};

const normalizeNested = (value) => {
  if (value instanceof Date) return value.toISOString();
  if (typeof value?.toDate === 'function') return value.toDate().toISOString();
  if (Array.isArray(value)) return value.map(normalizeNested);
  if (value && typeof value === 'object') return Object.fromEntries(
    Object.keys(value).sort().map((key) => [key, normalizeNested(value[key])]),
  );
  return value;
};

export const csvValue = (value) => {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) return value.toISOString();
  if (typeof value?.toDate === 'function') return value.toDate().toISOString();
  if (Array.isArray(value)) return JSON.stringify(normalizeNested(value));
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'object') {
    try { return JSON.stringify(normalizeNested(value)); } catch { return String(value); }
  }
  const text = String(value);
  return /^[=+\-@]/.test(text.trimStart()) ? `'${text}` : text;
};

export const buildCsv = (rows, preferredKeys = []) => {
  if (!rows?.length) return '';
  const flattened = rows.map((row) => flattenRecord(row));
  const keys = [...new Set([...preferredKeys, ...flattened.flatMap(Object.keys)])];
  const ordered = [...preferredKeys.filter((key) => keys.includes(key)),
    ...keys.filter((key) => !preferredKeys.includes(key)).sort()];
  const escape = (value) => `"${csvValue(value).replace(/"/g, '""')}"`;
  return [ordered.map(escape).join(','),
    ...flattened.map((row) => ordered.map((key) => escape(row[key])).join(','))].join('\n');
};

export const downloadCsv = (rows, name, preferredKeys = []) => {
  if (!rows.length) return false;
  saveAs(new Blob([buildCsv(rows, preferredKeys)], { type: 'text/csv;charset=utf-8;' }),
    `${name}.csv`);
  return true;
};
